import { Button, ButtonProps, Tooltip } from '@chronosphereio/chrono-ui';
import { ChartBoxPlusOutline as AddPanelIcon } from 'mdi-material-ui';
import { DASHBOARD_TOOLTIP_TEXT } from '../../constants';
import { useDashboardActions } from '../../context';

export interface AddPanelButtonProps extends Pick<ButtonProps, 'variant' | 'fullWidth'> {
  /**
   * The label used inside the button.
   */
  label?: string;
}

export const AddPanelButton = ({ variant = 'secondary', label = 'Panel', fullWidth }: AddPanelButtonProps) => {
  const { openAddPanel } = useDashboardActions();

  return (
    <Tooltip Content={DASHBOARD_TOOLTIP_TEXT.addPanel}>
      <Button
        StartIcon={<AddPanelIcon />}
        onClick={openAddPanel}
        aria-label={DASHBOARD_TOOLTIP_TEXT.addPanel}
        variant={variant}
        fullWidth={fullWidth}
        sx={{ whiteSpace: 'nowrap', minWidth: 'auto' }}
      >
        {label}
      </Button>
    </Tooltip>
  );
};
